/* eslint-disable */
import { takeEvery, call, put } from "redux-saga/effects";
import { GET_FORMPOST, SET_FORMPOST } from "../actions";
import api from "../utils/axios";
var qs = require("qs");
export const watchGetFormPost = function* () {
  yield takeEvery(GET_FORMPOST, workerGetFormPost);
};

function* workerGetFormPost({ formPayload, postUrl, method }) {
  try {
    const result = yield call(getFormPost, formPayload, postUrl, method);
    var resultArr = [];
    resultArr.push(result.data);
    yield put({ type: SET_FORMPOST, value: resultArr });
  } catch(e) {
    console.log(e, postUrl + " post failed");
    let returnerror = [];
    returnerror.push(e?.response?.data||[]);
    yield put({ type: SET_FORMPOST, value: returnerror });
    
  }
}

function getFormPost(formPayload, postUrl, method = "post") {
  // Choose HTTP method dynamically
  const requestMethod = method === "update" ? "put" : "post";
  return api[requestMethod](postUrl, formPayload);
}

